export * from 'SourceRoute/ProductPage/ProductPage.config';

export const PRODUCT_INSTALLMENT = 'installment';
export const STATIC_SECTION_CMS_BLOCK_ID = 'info_tiles';
